import { Item, ItemType } from '../../../redux/models/menu';
import { IMenuClickHandler } from '@uxdf/direct-shared-lib';

// top menu items configuration from BE is extended with this object
const DASHBOARD_ICON = '/assets/images/svg_ico/icons.svg#menu_dashboard';
const MENU_CONFIG = {
  home: {
    ico: '/assets/images/svg_ico/icons.svg#ic_home'
  },
  dashboard: {
    ico: DASHBOARD_ICON
  },
  'avc-dashboard': {
    ico: DASHBOARD_ICON
  },
  'avc-creditline': {
    ico: DASHBOARD_ICON
  },
  'amadeus-plus-me': {
    ico: '/assets/images/svg_ico/icons.svg#menu_loyalty'
  },
  book: {
    ico: '/assets/images/svg_ico/icons.svg#menu_book'
  },
  news: {
    ico: '/assets/images/svg_ico/icons.svg#menu_news'
  },
  store: {
    ico: '/assets/images/svg_ico/icons.svg#menu_store'
  },
  tasks: {
    ico: '/assets/images/svg_ico/icons.svg#menu_tasks'
  },
  account: {
    ico: '/assets/images/svg_ico/icons.svg#menu_account'
  },
  myAccount: {
    ico: '/assets/images/svg_ico/icons.svg#menu_account'
  }
};

export const SSO_CODES = ['SERVICE_HUB', 'COMMUNITY'];

export interface MenuItem extends Item {
  children: MenuItem[];
  link?: string;
  opened: boolean;
  cms_page_code: string;
  code: string;
  external_link: string;
  title: string;
  item_type: ItemType;
  clickHandler: (code: string, event: MouseEvent) => void;
}

export interface FilteredMenuList {
  navigation: MenuItem[];
}

export class MenuItemImpl implements MenuItem {
  cms_page_code: string;
  code: string;
  external_link: string;
  title: string;
  item_type: ItemType;
  children: MenuItem[];
  link?: string;
  opened = false;
  clickHandler: (code: string, event: MouseEvent) => void;

  private readonly linkResolvers = {
    cms_page: () => '/content/' + this.cms_page_code,
    code: () => '/' + this.code,
    title: () => '/' + this.code,
    external_link: () => this.external_link || null
  };

  // recursively convert menu item JSON configuration into Object's tree with children items
  constructor(item: Item, parent?: Item, clickHandlers?: IMenuClickHandler[]) {
    Object.assign(this, item);
    this.link = this.linkResolvers[this.item_type]();
    if (clickHandlers) {
      const clickHandler = clickHandlers.find(handler => handler.getCodes().indexOf(this.code) !== -1);
      this.clickHandler = clickHandler ? (code, event) => clickHandler.execute(code, event) : () => {};
    }
    if (!parent && MENU_CONFIG[item.code]) {
      Object.assign(this, MENU_CONFIG[item.code]);
    }
    this.children = (item.children || []).map(child => new MenuItemImpl(child, item, clickHandlers));
  }
}
